/*
 * よくあるご質問 (FAQ) interactions.
 * Nội dung render SERVER-SIDE trong page.content (body_html từ Laravel). JS chỉ lo:
 *   - accordion toggle (port shop.qa_page_script.tpl.php:77-83)
 *   - category page: もっと見る reveal +10 + ?qa_id → hiện hết + scroll
 *   - live search AJAX dropdown #resultBox (qua inkApi)
 *
 * Selector dùng class/id (KHÔNG data-* trong body_html — Shopify có thể sanitize).
 * Initial-hide index≥5 do JS tự enforce (phòng strip style="display:none").
 */
(function () {
  'use strict';

  const INITIAL_VISIBLE = 5;
  const REVEAL_STEP = 10;
  const MAX_REQUESTS_PER_MINUTE = 40;

  // category_id (1-6) → slug (khớp config qa.category_slugs + page handle qa-{slug}).
  const CATEGORY_SLUG = {
    1: 'ink', 2: 'insatsu', 3: 'tyumon', 4: 'henpin', 5: 'seikyu', 6: 'sonota',
  };

  const escapeHtml = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const qparam = (name) => new URLSearchParams(window.location.search).get(name);

  // Toggle hiện/ẩn dd khi click dt. Idempotent (data-bound).
  const bindToggle = (root) => {
    root.querySelectorAll('.Qa_list_item dt').forEach((dt) => {
      if (dt.dataset.bound) return;
      dt.dataset.bound = '1';
      dt.addEventListener('click', () => {
        const dd = dt.nextElementSibling;
        if (!dd) return;
        dt.parentElement.classList.toggle('is-active');
        const shown = dd.style.display === 'block' || !dd.style.display;
        dd.style.display = shown ? 'none' : 'block';
      });
    });
  };

  // showNextQA(n) — reveal n item đang display:none; hết thì ẩn nút (port script:56-71).
  const showNext = (dls, moreWrap, n) => {
    let remaining = n;
    let lastRevealed = false;
    for (let i = 0; i < dls.length && remaining > 0; i++) {
      if (dls[i].style.display === 'none') {
        dls[i].style.display = 'block';
        remaining -= 1;
        if (i === dls.length - 1) lastRevealed = true;
      }
    }
    if (lastRevealed && moreWrap) moreWrap.style.display = 'none';
  };

  // Category page: items render sẵn server-side. JS lo initial-hide + もっと見る + qa_id.
  const initCategoryPage = () => {
    const root = document.querySelector('[data-qa-category-page]');
    if (!root) return;
    const dls = root.querySelectorAll('.Qa_list_item');
    const moreWrap = root.querySelector('.Qa_search_moreBtn');
    const qaId = qparam('qa_id');

    if (qaId) {
      // Direct-link: hiện hết, ẩn nút, scroll (faithful !isset($qa_id)).
      dls.forEach((dl) => { dl.style.display = ''; });
      if (moreWrap) moreWrap.style.display = 'none';
      const el = document.getElementById(`dl_qa_${qaId}`);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'center' }), 200);
      return;
    }

    // Enforce hide index≥5 (phòng Shopify strip inline style).
    for (let i = INITIAL_VISIBLE; i < dls.length; i++) dls[i].style.display = 'none';
    if (moreWrap) {
      const btn = moreWrap.querySelector('span') || moreWrap;
      btn.addEventListener('click', () => showNext(dls, moreWrap, REVEAL_STEP));
    }
  };

  // ===== AJAX live search (dropdown #resultBox) — cần inkApi =====
  const bindSearch = (api) => {
    const input = document.getElementById('keyword');
    const resultBox = document.getElementById('resultBox');
    if (!input || !resultBox) return;

    let timer = null;
    let requestCount = 0;
    let windowStart = Date.now();

    const renderDropdown = (items) => {
      const inner = items && items.length
        ? `<ul>${items.map((it) => {
            const slug = CATEGORY_SLUG[it.category_id] || '';
            return `<li><a href="/pages/qa-${slug}?qa_id=${it.id}">${escapeHtml(it.question)}</a></li>`;
          }).join('')}</ul>`
        : '<span>結果なし</span>';
      resultBox.innerHTML =
        `<div class="searchBox__printerResultBox" id="search_box_result">` +
        `<div class="searchBox__printerResultBoxInner">${inner}` +
        `<button type="button" class="searchBox__closeIconBtn" data-qa-search-close aria-label="検索結果を閉じる"></button></div></div>`;
      const close = resultBox.querySelector('[data-qa-search-close]');
      if (close) close.addEventListener('click', () => { resultBox.innerHTML = ''; });
    };

    const doSearch = () => {
      const kw = input.value.trim();
      if (!kw) { resultBox.innerHTML = ''; return; }
      // Rate limit 40 req/min (faithful).
      if (Date.now() - windowStart > 60000) { requestCount = 0; windowStart = Date.now(); }
      if (requestCount >= MAX_REQUESTS_PER_MINUTE) {
        console.warn('1分間に40回のリクエストの上限に達しました。');
        return;
      }
      requestCount += 1;
      api.get('/qa/search', { keyword: kw }).then((res) => {
        if (!res || res.error) { console.warn('[qa] search failed', res && res.error); return; }
        renderDropdown(res.items);
      });
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(doSearch, 500); // debounce 500ms
    });
  };

  // Accordion + category: KHÔNG cần API → chạy ngay khi DOM sẵn sàng.
  const initStatic = () => {
    bindToggle(document);
    initCategoryPage();
  };

  // Search: cần inkApi → chờ ink:api:ready.
  const initSearch = () => { if (window.inkApi) bindSearch(window.inkApi); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatic);
  } else {
    initStatic();
  }
  if (window.inkApi) {
    initSearch();
  } else {
    document.addEventListener('ink:api:ready', initSearch, { once: true });
  }
})();
